import React, { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFetchDevicesMutation } from '~/api/controlDevice/ControlDevice.api';
import { queryToSearchCriteria } from '~/features/devices/utils/deviceQuery';

interface ShowResultsButtonProps {
    filters: any;
    onSubmit: () => void;
    isLoading?: boolean;
    processFilters: (filters: any) => any;
}

const ShowResultsButton: React.FC<ShowResultsButtonProps> = ({
    filters,
    onSubmit,
    isLoading: externalLoading = false,
    processFilters
}) => {
    const intl = useIntl();
    const [resultCount, setResultCount] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [fetchDevices] = useFetchDevicesMutation();

    const fetchFilteredDevicesCount = useRef(
        debounce((filters: any) => {
            setIsLoading(true);
            const processedFilters = processFilters(filters);
            const criteria: any = queryToSearchCriteria(processedFilters);
            fetchDevices({
                ...criteria,
                pageNumber: 0,
                pageSize: 1
            })
                .unwrap()
                .then((response) => {
                    setResultCount(response.totalElements || 0);
                })
                .catch(() => {
                    setResultCount(0);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }, 500)
    );

    useEffect(() => {
        fetchFilteredDevicesCount.current(filters);
    }, [filters]);

    return (
        <button
            className={`btn btn-primary ${(isLoading || externalLoading) ? 'btn-loading' : ''}`}
            onClick={onSubmit}
        >
            <FormattedMessage
                id='intl-msg:displayResults'
                values={{count: intl.formatNumber(resultCount)}}
                defaultMessage={`Show ${intl.formatNumber(resultCount)} results`}
            />
        </button>
    );
};

export default ShowResultsButton;
